module.exports = __webpack_public_path__ + "img/Carleton.afef730d.jpeg";